<div class="main-container">
    <app-sidebar-menu class="sidebar-shrink" *ngIf="isLogged"></app-sidebar-menu>
    <div class="content">
        <app-header [headerValue]="currentHeaderValue" *ngIf="isLogged"></app-header>
        <router-outlet></router-outlet>
    </div>
</div>
